<!--span class="fa-stack fa-lg" *ngIf="_data.configuration['chatEnabled']" data-toggle="tooltip" (click)="openSendModal()" data-placement="top" [title]="'sendNewMessage' | language">
  <i class="fa fa-circle fa-stack-2x text-secondary"></i>
  <i class="fa fa-envelope fa-stack-1x fa-inverse"></i>
</span>

<span class="fa-stack fa-lg" *ngIf="_data.configuration['alertEnabled']" data-toggle="tooltip" (click)="openAlertModal()" data-placement="top" [title]="'emergencyButton' | language">
  <i class="fa fa-circle fa-stack-2x text-danger"></i>
  <i class="fa fa-exclamation-triangle fa-stack-1x fa-inverse"></i>
</span-->

<span class="fa-stack fa-lg" *ngIf="_data.configuration['alertEnabled']" data-toggle="tooltip"
  (click)="openAlertModal()" data-placement="top" [title]="'emergencyButton' | language">
  <i class="fa fa-circle fa-stack-2x text-danger"></i>
  <i class="fa fa-exclamation-triangle fa-stack-1x fa-inverse"></i>
</span>

<span class="fa-stack fa-lg" [ngClass]="{'animated pulse infinite': getCountAllNotifications() > 0}"
  *ngIf="_data.configuration['chatEnabled']" data-toggle="tooltip" (click)="openSendModal()" data-placement="top"
  [title]="'sendNewMessage' | language">
  <i class="fa fa-circle fa-stack-2x text-secondary"></i>
  <i class="fa fa-envelope fa-stack-1x fa-inverse"></i>
</span>

<span *ngIf="getCountAllNotifications() > 0"
  class="message-notifications animated pulse infinite badge badge-pill badge-danger">{{ getCountAllNotifications() }}</span>

<app-modal [id]="'sendModal'" [large]="true" [resizable]=false [dragable]=false>
  <div modal-title>{{ "messageDesks" | language }}
    <button type="button" *ngIf="_data.configuration['activeSupervisor']" [ngClass]="{'active': showGlobalMessages}"
      (click)="showGlobalMessages = !showGlobalMessages" class="btn btn-sm btn-outline-light pull-right"><i
        class="fa fa-bullhorn" aria-hidden="true"></i> {{ "sendGlobalMessage" | language }}</button></div>
  <div modal-body class="pt-1 pr-2 pb-1 pl-2 chat-content">
    <div class="row">
      <div class="col-md-12">
        <div *ngFor="let a of alerts; let i = index" class="alert alert-warning alert-dismissible fade show"
          role="alert">
          {{ "generalMessage" | language }} {{ a.from_name }} ({{ a.office_name }}) {{ "alas" | language }}
          {{ a.hour }}<br>
          <strong>{{ a.msg }}</strong>
          <button type="button" class="close" (click)="deleteAlert(i)" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <div class="global-message" *ngIf="showGlobalMessages">
        <div class="col-md-12 mt-3">
          <div class="form-group">
            <label for="office">{{ "selectOfficeToSend" | language }}</label>
            <select id="office" class="form-control" [(ngModel)]="globalMessageOfficeSelected"
              (change)="getGlobalMessageDesks()">
              <option *ngFor="let o of globalMessageOffices" [value]="o.id">{{ o.name }}</option>
            </select>
            <label for="desks" class="mt-3 w-100">{{ "selectDeskToSend" | language }}
              <button (click)="unCheckAllGlobalDesks()" class="btn btn-sm btn-outline-dark float-right"><i
                  class="fa fa-square-o" aria-hidden="true"></i> {{ "unCheckAll" | language}}</button>
              <button (click)="checkAllGlobalDesks()" class="btn btn-sm btn-outline-dark float-right mr-2"><i
                  class="fa fa-check-square-o" aria-hidden="true"></i> {{ "checkAll" | language}}</button>
            </label>
            <div class="scroll-desks" id="desk-select">
              <ul class="list-group">
                <li class="list-group-item" *ngFor="let d of globalMessageDesks"><input [id]="d.id"
                    [(ngModel)]="d.checked" type="checkbox" class="cursor-pointer"> <label [for]="d.id"
                    class="cursor-pointer">{{ d.title }}</label></li>
              </ul>
            </div>
            <label for="message" class="mt-3">{{ "messageToSend" | language }}</label>
            <input [(ngModel)]="globalMessage" type="text" class="form-control">
            <div *ngIf="globalMessageOk" class="alert alert-success mt-3">{{ "messageSended" | language }}</div>
            <button *ngIf="!globalMessageOk" class="btn btn-success mt-2 float-right" (click)="sendGlobalMessage()"><i
                class="fa fa-paper-plane-o" aria-hidden="true"></i> {{ "send" | language }}</button>
          </div>
        </div>
      </div>
      <div class="col-md-4 bg-grey aside">
        <h5 class="mt-2">{{ "online" | language }} ({{getDesksAvailables().length}})</h5>
        <p class="text-center mt-3" *ngIf="getDesksAvailables().length == 0">{{ "desksOffile" | language }}</p>
        <div class="scroll-online-list mt-2">
          <ul class="list-group list-group-flush">

            <a *ngFor="let d of getDesksAvailables()" (click)="openConversation(d)"
              class="cursor-pointer rounded-0 list-group-item list-group-item-action flex-column align-items-start"
              [ngClass]="{'active': actualConversation && actualConversation.id == d.id}">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{ (d.title.length>15)? (d.title | slice:0:15)+'..':(d.title) }}</h5>
                <span *ngIf="getCountNotifications(d.id) > 0"
                  class="badge badge-success badge-pill">{{ getCountNotifications(d.id) }}</span>
              </div>
              <small *ngIf="lastMessage(d.id) != null"><span class="float-left"><span
                    *ngIf="lastMessage(d.id)['messageByMe']">{{ "me" | language }}: </span>
                  {{ (lastMessage(d.id)['msg'].length>12)? (lastMessage(d.id)['msg'] | slice:0:12)+'..':(lastMessage(d.id)['msg']) }}</span>
                <span class="float-right">{{ lastMessage(d.id)['hour'] }}</span></small>
            </a>
          </ul>
        </div>
      </div>
      <div class="col-md-8 pl-0 pt-0 pb-0 pr-3 bg-grey">
        <div *ngIf="actualConversation">
          <h5 class="p-2">{{ actualConversation.title }}</h5>
          <div id="chat-view" class="scrolled-chat pl-3 pr-3 pb-3">
            <ng-container *ngFor="let msg of actualConversationMessages">
              <div class="message" *ngIf="msg.msg.length != 0">
                <div class="chat-message" [ngClass]="{'me': msg.messageByMe}">
                  {{ msg.msg }}
                  <div class="hour"><i *ngIf="msg.messageByMe && msg.readed" class="fa fa-eye" aria-hidden="true"></i>
                    {{ msg.hour }}</div>
                </div>
              </div>
            </ng-container>
          </div>
          <form (submit)="send()">
            <div class="input-group ml-2">
              <input class="form-control border-0 rounded-0 message-input" [(ngModel)]="messageForm['content']"
                [ngModelOptions]="{standalone: true}" placeholder="Escribe un mensaje">
              <button class="btn btn-success rounded-0 border-white" type="submit"><i class="fa fa-paper-plane"
                  aria-hidden="true"></i></button>
            </div>
          </form>
        </div>
        <div class="text-center pb-6" *ngIf="!actualConversation">
          <i class="fa fa-commenting-o fa-3x mb-2 mt-4" aria-hidden="true"></i><br>
          {{ "selectConversation" | language }}
        </div>
      </div>
    </div>
  </div>
</app-modal>

<app-modal [id]="'receivedModal'" [canIclose]="false">
  <span *ngIf="message && message['to'] != 'all'" modal-title>{{ "messageForm" | language }}
    {{ message.from_name }}</span>
  <span *ngIf="message && message['to'] == 'all'" modal-title>{{ "emergencyIn" | language }}
    {{ message.from_name }}</span>
  <div modal-body>
    <div class="scrolled">
      <div *ngIf="message" class="alert"
        [ngClass]="{'alert-light':message.type == 0, 'alert-danger':message.type == 1}">
        <span *ngIf="message" class="text-dark">
          <p class="text-center" *ngIf="message['type'] == 1"><i
              class="fa fa-exclamation-triangle fa-3x animated flash infinite text-danger" aria-hidden="true"></i></p>
          {{ message.msg }}
        </span>
        <hr>
      </div>
      <button (click)="markAsRead()" class="btn btn-success">
        <i class="fa fa-check" aria-hidden="true"></i> {{ "markAsRead" | language }}
      </button>
      <button *ngIf="message && message['type'] == 0"
        (click)="openSendModal(message['from'], _data.configuration['autoResponse'])" class="btn btn-primary">
        <i class="fa fa-paper-plane" aria-hidden="true"></i> {{ "reply" | language }}
      </button>
    </div>
  </div>
</app-modal>

<app-modal [id]="'questionAlertModal'">
  <span modal-title>{{ "confirmation" | language }}</span>
  <div modal-body>
    <div class="scrolled">
      <p class="text-center"><i class="fa fa-exclamation-triangle fa-3x" aria-hidden="true"></i></p>
      <p>
        {{ "confirmAlert" | language }}
      </p>
      <button (click)="sendAlert()" class="btn btn-success float-right">
        <span *ngIf="status==0"><i class="fa fa-paper-plane" aria-hidden="true"></i>
          {{ "yesSendAlert" | language }}</span>
        <span *ngIf="status==1"><i class="fa fa-spinner fa-pulse fa-fw" aria-hidden="true"></i>
          {{ "sending" | language }}...</span>
        <span *ngIf="status==2"><i class="fa fa-check" aria-hidden="true"></i> {{ "sent" | language }}</span>
      </button>
      <button class="btn btn-danger" (click)="_modal.hide('questionAlertModal')">
        <i class="fa fa-times" aria-hidden="true"></i> {{ "cancel" | language }}
      </button>
    </div>
  </div>
</app-modal>
